import { ReactNode } from 'react';
import { TabWrapper } from './styles';

type TabType = {
  isActive?: boolean;
  value?: string;
  children: ReactNode;
  disabled?: boolean;
};

export const Tab = ({ isActive, value, children, disabled }: TabType) => {
  return (
    <TabWrapper isActive={isActive} data-value={value} disabled={disabled}>
      {children}
    </TabWrapper>
  );
};
